import type { CardFeatures } from '../../CardFeatures';
import { accountLinkage } from '../account-linkage/HU';
import { dynamicCurrencyConversion } from '../card-dynamic-currency-conversion/HU';
import { cardImage } from '../card-image/HU';
import { cardInsurance } from '../card-insurance/HU';
import { limitsChange } from '../card-limits-change/HU';
import { cardLimitsFocusPage } from '../card-limits-focus-page/HU';
import { limits } from '../card-limits/combined-limits/HU';
import { permanentLimitsLegacy } from '../card-limits/permanent-limits-legacy/HU';
import { permanentLimits } from '../card-limits/permanent-limits/HU';
import { temporaryLimits } from '../card-limits/temporary-limits/HU';
import { cardLockAndReplace } from '../card-lock-and-replace/HU';
import { cardLock } from '../card-lock/HU';
import { prepaidCardInfo } from '../card-prepaid-info/HU';
import {
    card3DSecureCode,
    card3DSecureCodeEncryption,
} from '../card-services/card-3d-secure-code/HU';
import { automaticCardReplacement } from '../card-services/card-automatic-replacement/HU';
import { cardCancellation } from '../card-services/card-cancellation/HU';
import { cardDelivery } from '../card-services/card-delivery/HU';
import { changeCardDesign } from '../card-services/card-design-change/HU';
import { cardLoyaltyProgramExternal } from '../card-services/card-loyalty-external/HU';
import { supplementaryCardInstallments } from '../card-services/supplementary-card-installments/HU';
import { cardMigrationExternal } from '../card-services/card-migration-external/HU';
import { creditCardReissueExternal } from '../card-services/card-reissue-external/HU';
import { cardReissue } from '../card-services/card-reissue/HU';
import { orderReplacementCard } from '../card-services/card-replacement/HU';
import { cardDetails, cardDetailsEncryption } from '../card-services/card-secured-details/HU';
import { changeCardDelivery } from '../card-services/delivery-management-v2/HU';
import { displayPin, displayPinEncryption } from '../card-services/display-pin/HU';
import { changePinDelivery } from '../card-services/pin-delivery-change/HU';
import { pinDeliveryFromCardDelivery } from '../card-services/pin-delivery-from-card-delivery/HU';
import { pinDelivery } from '../card-services/pin-delivery/HU';
import { reprintPinFocusPage } from '../card-services/reprint-pin-focus-page/HU';
import { reprintPin } from '../card-services/reprint-pin/HU';
import { cardTracking } from '../card-tracking/HU';
import { cardUnlock } from '../card-unlock/HU';
import { bankCardLimitChange } from '../cards-bank/card-limit-changes/HU';
import { cardLimitInfo } from '../cards-bank/card-limit-info/HU';
import { cardReplacement } from '../cards-bank/card-replacement/HU';
import { geoControl } from '../cards-bank/geo-control/HU';
import { linkedAccounts } from '../cards-bank/linked-accounts/HU';
import { microCardActivation } from '../cards-bank/micro-card-activation/HU';
import { microSticker } from '../cards-bank/micro-sticker/HU';
import { cardServices } from '../cards-credit/additional-services/HU';
import { cardFees } from '../cards-credit/card-fees/HU';
import { creditCardLimitChange } from '../cards-credit/card-limit-change/HU';
import { creditCardLimitInfo } from '../cards-credit/card-limit-info/HU';
import { creditCardMeter } from '../cards-credit/card-meter/HU';
import { creditCardDirectDebit } from '../cards-credit/direct-debit/HU';
import { creditCardPayUp } from '../cards-credit/pay-up/HU';
import { autoRepayment } from '../cards-credit/repayment/HU';
import { creditCardStatements } from '../cards-credit/statements/HU';
import { contactlessPayments } from '../contactless-payments/HU';
import { expirationTime } from '../expiration-time/HU';
import { installmentsActivation } from '../installments-activation/HU';
import { installments } from '../installments/HU';
import { temporaryDeactivation } from '../temporary-deactivation/HU';
import { topUp } from '../top-up/HU';
import { upcomingInstallments } from '../upcoming-installments/HU';

export const cards: CardFeatures = {
    accountLinkage,
    autoRepayment,
    bankCardLimitChange,
    card3DSecureCode,
    card3DSecureCodeEncryption,
    cardCancellation,
    cardDelivery,
    cardDetails,
    cardDetailsEncryption,
    cardFees,
    cardInsurance,
    cardLimitInfo,
    cardLock,
    cardLockAndReplace,
    cardLoyaltyProgramExternal,
    cardMigrationExternal,
    cardReissue,
    cardReplacement,
    cardServices,
    cardTracking,
    supplementaryCardInstallments,
    cardUnlock,
    changeCardDesign,
    contactlessPayments,
    creditCardLimitChange,
    creditCardLimitInfo,
    creditCardReissueExternal,
    creditCardStatements,
    displayPin,
    displayPinEncryption,
    dynamicCurrencyConversion,
    expirationTime,
    geoControl,
    installments,
    installmentsActivation,
    upcomingInstallments,
    limits,
    limitsChange,
    linkedAccounts,
    microCardActivation,
    microSticker,
    permanentLimits,
    permanentLimitsLegacy,
    pinDelivery,
    pinDeliveryFromCardDelivery,
    prepaidCardInfo,
    reprintPin,
    temporaryDeactivation,
    temporaryLimits,
    topUp,
    cardLimitsFocusPage,
    creditCardPayUp,
    reprintPinFocusPage,
    automaticCardReplacement,
    changePinDelivery,
    changeCardDelivery,
    creditCardDirectDebit,
    orderReplacementCard,
    creditCardMeter,
    cardImage,
    relyOnPAPIDataForCards: {
        enabled: false,
    },
    redesignedCardContentBox: {
        enabled: true,
    },
    redesignedDebitCardContentBox: {
        enabled: true,
    },
    additionalCreditCards: {
        enabled: false,
    },
    cardsTicketing: {
        enabled: true,
    },
    nativeCardOrder: {
        enabled: false,
    },
    nativeCardReplacement: {
        enabled: false,
    },
};
